/**
 * The tenant in scope — story 0.5 AC-8.
 *
 * Separate from `TenantScope.tsx` because a file that exports both a component and
 * a hook breaks React Fast Refresh, and the repo holds lint at zero warnings.
 *
 * 🔒 **It returns `string`, not `string | null`, and that is the point.** The scope
 * is a layout route, so a scoped screen renders as its child or not at all — there
 * is no reachable state where a FinOps tab exists without a client. Typing it as
 * nullable would push a meaningless null check into every screen and make the
 * structural guarantee look optional.
 */
import { createContext, useContext } from 'react'

export const ContextoDeCliente = createContext<string | null>(null)

export function useClienteAtual(): string {
  const idCliente = useContext(ContextoDeCliente)
  if (!idCliente) {
    // A screen that needs a client and does not have one is a ROUTING bug. Failing
    // loudly in dev is cheaper than rendering an empty grid and wondering why.
    throw new Error(
      'useClienteAtual() precisa estar dentro de <TenantScope> — a tela é escopada por cliente (BR-19).',
    )
  }
  return idCliente
}
